<template>
  <div class="flex justify-center align-center flex-wrap">
    <div v-for="restaurant in restaurantsFiltered" :key="restaurant.name">
      <RestaurantCard
        :restaurant="restaurant"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RestaurantCard from '@/components/RestaurantCard.vue'

export default {
  name: 'Restaurants',
  components: {
    RestaurantCard
  },
  computed: {
    ...mapState(['restaurants', 'filter']),
    restaurantsFiltered () {
      if (this.filter !== 'All') {
        return this.restaurants.filter(element => element.world === this.filter)
      } else {
        return this.restaurants
      }
    }
  }
}
</script>

<style>

</style>
